export enum LanguageAvailabilityByProduct {
    DoNotConsiderAvailability = 0,
    BehavioralAssessment = 1,
    JobAssessment = 2,
    FullSite = 3,
    Guides = 4,
    GroupAnalytics = 5,
    BehavioralReports = 6,
    JobReports = 7,
    ORQ = 8,
    Placard = 9,
    PDC = 10,
    Cognitive = 11,
    CognitiveJA = 12,
    CognitiveReports = 13,
    GenderNeutralReports = 14
}

export enum LanguageContextType {
    PI2SoftwareLanguages = 0,
    BehavioralAssessment = 1,
    CognitiveAssessment = 2
}

export enum HttpHeaderContentType {
    JSON = 'application/json',
    PNG = 'image/png',
    JPEG = 'image/jpeg',
    PDF = 'application/pdf',
    CSV = 'text/csv',
    TEXT = 'text/html',
    ZIP = 'application/zip'
}

export enum GuideFactorCategory {
    Fit = 'fit',
    Gap = 'gap'
}

export enum GuideFactorCondition {
    High = 'high',
    Low = 'low'
}

export enum AppType {
    Main = 0,
    Design = 1,
    Hire = 2,
    Diagnose = 3,
    Inspire = 4,
    Admin = 5,
    Platform = 6,
    GroupAnalytics = 7,
    SellerExperience = 8
}

export enum PIVersion {
    One = 1,
    Two = 2
}
